import { vendorInfoRoute } from './components/VendorInfo';
import { vendorResourcesRoute } from './components/VendorResources';

export default () => [vendorInfoRoute, vendorResourcesRoute];
